import { useContext, useMemo } from 'react';
import { IncentivesContext, FiltersContext } from '../contexts';
import { getCascadingFacetOptions } from '../utils/filterVehicles';

const useFacetFilter = (facetKey) => {
	const { incentives, showcaseMappings } = useContext(IncentivesContext);
	const { activeFilters, selectFacet, deselectFacet, clearGroup, clearAll } =
		useContext(FiltersContext);

	const availableOptions = useMemo(
		() =>
			getCascadingFacetOptions(
				incentives?.byVehicle,
				activeFilters,
				facetKey,
				showcaseMappings?.mappingRules || null
			),
		[incentives?.byVehicle, activeFilters, facetKey, showcaseMappings]
	);

	const selectedValues = activeFilters?.[facetKey] || [];

	const handleToggle = (slug) => {
		if (selectedValues.includes(slug)) {
			deselectFacet(facetKey, slug);
		} else {
			selectFacet(facetKey, slug);
		}
	};

	const clearFacet = () => clearGroup(facetKey);

	return {
		availableOptions,
		selectedValues,
		handleToggle,
		clearFacet,
		clearAll
	};
};

export default useFacetFilter;
